export default function supabaseLoader({
    src,
    width,
    quality,
}: {
    src: string
    width: number
    quality?: number
}) {
    const CUSTOM_STORAGE_HOST = 'https://ecodata.ecommaps.com';

    // 1. Return original if it's not a storage URL and not a relative path we can resolve
    if (!src.includes('supabase.co') && !src.includes('ecodata.ecommaps.com') && src.startsWith('http')) {
        // Next.js warns if loader doesn't incorporate width. We append it to satisfy constraints.
        const url = new URL(src);
        url.searchParams.set('width', width.toString());
        if (quality) url.searchParams.set('quality', quality.toString());
        return url.toString();
    }

    // 2. Extract the path from a full storage URL
    let path = src;
    const isFullStorageUrl = src.includes('/storage/v1/object/public/');

    if (isFullStorageUrl) {
        const parts = src.split('/public/');
        if (parts.length === 2) {
            path = parts[1] || src;
        }
    } else if (src.startsWith('/')) {
        path = src.substring(1);
    }

    // If it's a local static asset (like /placeholder.png), DON'T send it to CDN
    if (src.startsWith('/') && !path.startsWith('store-assets') && !path.startsWith('store-logos')) {
        return `${src}?width=${width}&quality=${quality || 75}`;
    }

    // Ecommaps Image Transformation endpoint (via custom domain):
    // https://ecodata.ecommaps.com/storage/v1/render/image/public/[bucket]/[path]?width=[width]&quality=[quality]

    return `${CUSTOM_STORAGE_HOST}/storage/v1/render/image/public/${path}?width=${width}&quality=${quality || 75}&resize=contain`
}

